import React, { Component } from 'react'
import { connect } from 'react-redux'
import FeesForm from './fees_form'
import FeesListFilter from './feesListFilter'
import * as actions from '../../actions'
// import { reduxForm, Field } from 'redux-form'
// import { renderTextField, renderCheckbox, renderSelectField } from '../auth/form_helpers'
// import MenuItem from 'material-ui/MenuItem';
// import Paper from 'material-ui/Paper';
import {List, ListItem} from 'material-ui/List';
import ActionPayment from 'material-ui/svg-icons/action/payment';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton'
import {lightBlack, darkBlack} from 'material-ui/styles/colors';
import Dialog from 'material-ui/Dialog';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import AppBar from 'material-ui/AppBar';
import Waypoint from 'react-waypoint';

var FileSaver = require('file-saver');

var jsonpatch = require('fast-json-patch')
const uuidv4 = require('uuid/v4');
var params = '?';
// var hasEdited = false;
var hasEdited = false;
var patchresponsed = true;

const styles = {
  m15: {
    margin: 15,
  },
  customContentStyle: {
    width: '100%',
    maxWidth: 'none',
  },
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  plusButton: {
    position: "fixed",
    right: 20,
    bottom: 20,
    zIndex: 1,
  }
};

var shouldSave = true;
var closeRequest = null

class Fees extends Component {

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.authError(null)
    }
    closeRequest = null
  }

  componentWillMount() {
    this.props.fetchMessage('/fees', '?offset=0&limit=50');
    // this.props.getEnums('/stats/group-amounts', '?by=year', 'GroupsByYear'); // Filter : year
    this.props.getEnums('/dev.enum/fee-types', '', 'FeeTypes');
  }

  componentDidMount() {
    var that = this
    closeRequest = function() {
      window.onbeforeunload = function() {
        that.setState({iscloserequest: true});
        that.handleFakeSubmit(false)
        if (that.state.openedform) {
          if (!that.state.isemptyonclose) {
            that.setState({iscloserequest: false});
            return 'You have unsaved changes!';
          }

        }
      }
    }
    closeRequest()
    let actualHref = window.location.href;
    if ( actualHref.substring(actualHref.length - 5).indexOf('fees') === -1 ) {
      let editPath = actualHref.substring((actualHref.indexOf('fees') + 5))
      window.history.pushState({"html":document.documentElement.innerHTML,"pageTitle":document.title},"", actualHref.substring( 0, (actualHref.indexOf('fees') + 4) ));
      this.props.openFee('', editPath, '', '');
      this.setState({open: true});
      this.setState({openedform: true});
    }
  }

  state = {
    open: false,
    openedform: false,
    iscloserequest: false,
    isemptyonclose: false,
    filterparams: "?",
  }

  openReferedFee = () => {
    /*
    let thisForFunction = this
    setTimeout(function(){
      let actualHref = window.location.href;
      if ( actualHref.substring(actualHref.length - 5).indexOf('fees') === -1 ) {
        let editPath = actualHref.substring((actualHref.indexOf('fees') + 5))
        window.history.pushState({"html":document.documentElement.innerHTML,"pageTitle":document.title},"", actualHref.substring( 0, (actualHref.indexOf('fees') + 4) ));
        thisForFunction.props.openFee('', editPath, '', '');
        thisForFunction.setState({open: true});
        this.setState({openedform: true});
      }
    }, 500)
    */
  }

  handleOpen = ( val , item, type) => {
    this.props.openFee('', val, item, type);
    this.setState({open: true});
    this.setState({openedform: true});
  }

  handleNewOpen = ( val ) => {
    this.props.openFee('', val, null, null);
    this.setState({open: true});
    this.setState({openedform: true});
  }

  handleClose = () => {
    this.handleFakeSubmit(false);
    //if (hasEdited) {
    //  if (confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.')) {
    //  this.props.closeFee()
    //  this.props.fetchMessage('/fees', params);
    //  this.setState({open: false});
    //  }
    //} else {
    //  this.props.closeFee()
    //  this.props.fetchMessage('/fees', params);
    //  this.setState({open: false});
    //}
  }

  handleSubmit({editPath, id, amount, payed, paymentDate, invoiceNumber, year, notice1, notice2, isRemissed, typeNew, idNewid, idNewGroupid, idNew, idNewGroup, type, reason}) {
    let patchArrayCounter = 0;
    patchresponsed = true
    let patchArray = []
    let dateString0;
    if (typeof paymentDate !== 'undefined' && paymentDate !== null) {
      if(paymentDate.length === 10) {
        dateString0 = paymentDate;
      } else {
        if(typeof paymentDate === 'string'){paymentDate = new Date(paymentDate)}
        paymentDate.setMinutes(paymentDate.getMinutes() - paymentDate.getTimezoneOffset());
        // dateString0 = paymentDate.toLocaleDateString('hu-HU').replace(/[.]/g, '-').replace(/[' ']/g, '').replace(/-$/, '')
        dateString0 = paymentDate.toISOString().slice(0,10)
      }
    }
    let dateString1;
    if (typeof notice1 !== 'undefined' && notice1 !== null) {
      if(notice1.length === 10) {
        dateString1 = notice1;
      } else {
        if(typeof notice1 === 'string'){notice1 = new Date(notice1)}
        notice1.setMinutes(notice1.getMinutes() - notice1.getTimezoneOffset());
        // dateString1 = notice1.toLocaleDateString('hu-HU').replace(/[.]/g, '-').replace(/[' ']/g, '').replace(/-$/, '')
        dateString1 = notice1.toISOString().slice(0,10)
      }
    }
    let dateString2;
    if (typeof notice2 !== 'undefined' && notice2 !== null) {
      if(notice2.length === 10) {
        dateString2 = notice2;
      } else {
        if(typeof notice2 === 'string'){notice2 = new Date(notice2)}
        notice2.setMinutes(notice2.getMinutes() - notice2.getTimezoneOffset());
        //dateString2 = notice2.toLocaleDateString('hu-HU').replace(/[.]/g, '-').replace(/[' ']/g, '').replace(/-$/, '')
        dateString2 = notice2.toISOString().slice(0,10)
      }
    }
    if (this.props.thisfee.editPath.length === 36) {
      if(typeNew === 'group-registration-fee') {
        editPath = '/groups/'+idNewGroupid+'/group-registration-fee'
      } else if (typeNew === 'membership-fee') {
        editPath = '/persons/'+idNewid+'/membership-fees/'+editPath
      } else {
        // editPath = '/persons/<personId>/registration-fees/<groupId>'
        editPath = '/groups/'+idNewGroupid+'/registration-fees/'+idNewid
      }
    }

    let loadedfee = {
      "amount" : typeof this.props.thisfee.amount === 'string' ? parseInt(String(this.props.thisfee.amount).replace(/[' ']/g,''), 10) : this.props.thisfee.amount,
      "payed" : typeof this.props.thisfee.payed === 'string' ? parseInt(String(this.props.thisfee.payed).replace(/[' ']/g,''), 10) : this.props.thisfee.payed,
    }
    if (typeof this.props.thisfee.paymentDate !== 'undefined') {
      loadedfee.paymentDate = this.props.thisfee.paymentDate
    }
    if (typeof this.props.thisfee.invoiceNumber !== 'undefined' && this.props.thisfee.invoiceNumber !== '') {
      loadedfee.invoiceNumber = this.props.thisfee.invoiceNumber
    }

    let edited = {
      "amount" : typeof amount === 'undefined' ? amount : parseInt(String(amount).replace(/[' ']/g,''), 10),
      "payed" : typeof payed === 'undefined' ? payed : parseInt(String(payed).replace(/[' ']/g,''), 10),
    }
    if (typeof paymentDate !== 'undefined') {
      edited.paymentDate = dateString0
    }
    if (typeof invoiceNumber !== 'undefined' && invoiceNumber !== '') {
      edited.invoiceNumber = invoiceNumber
    }
    if (type === 'membership-fee' || typeNew === 'membership-fee') {
      if (typeof this.props.thisfee.id !== 'undefined') {
        loadedfee.id = this.props.thisfee.id;
      }
      edited.id = id;
      if (typeof this.props.thisfee.notice1 !== 'undefined') {
        loadedfee.notice1 = this.props.thisfee.notice1;
      }
      edited.notice1 = dateString1;
      if (typeof this.props.thisfee.notice2 !== 'undefined') {
        loadedfee.notice2 = this.props.thisfee.notice2;
      }
      edited.notice2 = dateString2;
      if (typeof this.props.thisfee.year !== 'undefined') {
        loadedfee.year = this.props.thisfee.year;
      }
      edited.year = typeof year === 'undefined' ? year : parseInt(year, 10);
      if (typeof this.props.thisfee.isRemissed !== 'undefined') {
        loadedfee.isRemissed = this.props.thisfee.isRemissed === '' ? false : (this.props.thisfee.isRemissed ? true : false);
      }
      edited.isRemissed = isRemissed === '' ? false : (isRemissed ? true : false);
    }
    if (type === 'registration-fee' || typeNew === 'registration-fee') {
      if (typeof this.props.thisfee.notice1 !== 'undefined') {
        loadedfee.notice1 = this.props.thisfee.notice1;
      }
      edited.notice1 = dateString1;
      if (typeof this.props.thisfee.notice2 !== 'undefined') {
        loadedfee.notice2 = this.props.thisfee.notice2;
      }
      edited.notice2 = dateString2;
      if (typeof this.props.thisfee.isRemissed !== 'undefined') {
        loadedfee.isRemissed = this.props.thisfee.isRemissed === '' ? false : (this.props.thisfee.isRemissed ? true : false);
      }
      edited.isRemissed = isRemissed === '' ? false : (isRemissed ? true : false);
    }
    var patch = jsonpatch.compare(loadedfee, edited)

    patchArray.push({
      endpoint: '',
      params: editPath,
      patchvar: patch,
      needalert: false
    })
    let propsforpatch = this.props;
    let that = this;
    let cntrObj = {}
    cntrObj.lngt = patchArray.length;
    function patcher(maybeSave) {
      if (typeof maybeSave !== 'undefined' && maybeSave === true) {

        if (patchresponsed === true) {
          console.log('? patchArray.length === patchArrayCounter '+patchArray.length+'-'+patchArrayCounter)
          if (patchArray.length === patchArrayCounter) {
            // All PATCH done
            propsforpatch.fetchMessage('/fees', params); // refresh list
            hasEdited = false;
            propsforpatch.openFee('', editPath, ''); // refresh single
            //propsforpatch.openGroup('/groups', '/'+id); // refresh single
            alert('Sikeres módosítás')
            patcher = null
          } else {
            document.getElementsByTagName("body")[0].addEventListener('patchresponse'+patchArrayCounter, function (e) {
              // we have response
              patchresponsed = true
              patchArrayCounter++
              if (patcher !== null) {
                patcher(shouldSave);
              }
            }, false)
            if (typeof patchArray[patchArrayCounter] !== 'undefined' && typeof patchArray[patchArrayCounter].del !== 'undefined' && patchArray[patchArrayCounter].del === true) {
              propsforpatch.deleteParticipant(patchArray[patchArrayCounter].endpoint, patchArray[patchArrayCounter].params, patchArrayCounter)
            } else {
              propsforpatch.patchItem(patchArray[patchArrayCounter].endpoint, patchArray[patchArrayCounter].params, patchArray[patchArrayCounter].patchvar, patchArray[patchArrayCounter].needalert, patchArrayCounter)
            }
            patchresponsed = false
          }
        }

      } else {
        if (that.state.iscloserequest) { // EZ LETT BERAKVA
          let isEmpty = true
          patchArray.map((option, index) => {
            if (option.patchvar.length > 0) {
              isEmpty = false
            }
          })
          if (isEmpty) {
            that.setState({isemptyonclose : true})
            return true
          } else {
            that.setState({isemptyonclose : false})
            return false
          }
        } else {
          let isEmpty = true
          patchArray.map((option, index) => {
            if (option.patchvar.length > 0) {
              isEmpty = false
            }
          })
          if (isEmpty) {
            propsforpatch.closeFee()
            propsforpatch.fetchMessage('/fees', params);
            that.setState({open: false});
            that.setState({openedform: false});
          } else {
            if (window.confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.\n\nBezárjuk a form-ot?')) {
            propsforpatch.closeFee()
            propsforpatch.fetchMessage('/fees', params);
            that.setState({open: false});
            that.setState({openedform: false});
            }
          }
        }

      }
    }

    patcher(shouldSave);

    /*
    if (shouldSave === true) {
      this.props.patchItem('', editPath, patch)
      this.props.fetchMessage('/fees', params);
      // hasEdited = false;
      this.props.openFee('', editPath, '')
    } else {
      if (patch.length > 0) {
        if (confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.\n\nBezárjuk a form-ot?')) {
          this.props.closeFee()
          this.props.fetchMessage('/fees', params);
          this.setState({open: false});
        }
      } else {
        this.props.closeFee()
        this.props.fetchMessage('/fees', params);
        this.setState({open: false});
      }
    }
    */
  }

  scrollTo = (element, to, duration) => {
      //t = current time
      //b = start value
      //c = change in value
      //d = duration
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      var start = element.scrollTop,
          change = to - start,
          currentTime = 0,
          increment = 20;
          
      var animateScroll = function(){        
          currentTime += increment;
          var val = Math.easeInOutQuad(currentTime, start, change, duration);
          element.scrollTop = val;
          if(currentTime < duration) {
              setTimeout(animateScroll, increment);
          }
      };
      animateScroll();
  }

  handleFilter({query, type, year, hasDebit}) {
    params = '?';
    if (typeof query !== 'undefined') {
      params = params + '&q='+query
    }
    if (typeof type !== 'undefined') {
      params = params + '&type='+type
    }
    if (typeof year !== 'undefined' && year !== 'all') {
      params = params + '&year='+year
    }
    if (typeof hasDebit !== 'undefined') {
      params = params + '&hasDebit='+hasDebit
    }
    window.scrollTo(document.body, 0, 1250);
    this.setState({filterparams: params});
    this.props.fetchMessage('/fees', params);
  }

  handleFakeSubmit = (should) => {
    if (should === false) {
      shouldSave = false;
      let classes = document.getElementsByClassName('FeeFormSubmitButton');
      if (typeof classes !== 'undefined' && classes.length > 0) {
        let Rate = classes[0];
        let Btn = Rate.getElementsByTagName('button')[0];
        Btn.click();
      } else {
        this.setState({open: false});
      }
    } else {
      shouldSave = true;
      let classes = document.getElementsByClassName('FeeFormSubmitButton');
      if (typeof classes !== 'undefined' && classes.length > 0) {
        let Rate = classes[0];
        let Btn = Rate.getElementsByTagName('button')[0];
        Btn.click();
      } else {
        this.setState({open: false});
      }
    }
  }
  
  csvExport = () => {
    let d = new Date();
    let t = d.getTime();
    let fullparam = '?'
    if (typeof this.state.filterparams !== 'undefined' && this.state.filterparams !== '') {
      if (this.state.filterparams.indexOf('?') > -1) {
        fullparam = this.state.filterparams+'&t='+t
      } else {
        fullparam = '?'+this.state.filterparams+'&t='+t
      }
    } else {
      fullparam = fullparam+'t='+t
    }
    var request = new XMLHttpRequest();
    request.open('GET', 'https://admin.magyarpszichodrama.hu/api/v1.0/fees.csv'+fullparam);
    request.responseType = 'blob';
    request.setRequestHeader('X-Auth-Token', localStorage.getItem('token'));
    var blob;
    request.onload = function() {
      blob = request.response;
      FileSaver.saveAs(blob, "fees.csv");
    };
    request.send();
  }

  render() {
    if(typeof this.props.message !== 'undefined' && typeof this.props.feetypes !== 'undefined') {
      let uu = uuidv4();
      //this.openReferedFee()
      return (
        <div style={{paddingBottom: 351}}>
          <AppBar
            title="Befizetések"
          />
          <Dialog
            actions={[
              <RaisedButton label='Mentés' onTouchTap={ this.handleFakeSubmit } primary={true} />,
              <FlatButton label='Bezár' onTouchTap={ this.handleClose } />
              //<FlatButton label='Bezár' onTouchTap={shouldSave = false; this.handleFakeSubmit } />
            ]}
            modal={false}
            open={this.state.open}
            onRequestClose={this.handleClose}
            autoScrollBodyContent={true}
            contentStyle={{width: '100%', maxWidth: 'none'}}
          >
            <FeesForm
              handleClose={this.handleClose.bind(this)}
              onSubmit={this.handleSubmit.bind(this)}
              errorMessage={this.props.errorMessage}
              feetypes={this.props.feetypes}
              feeinfos={this.props.thisfee}
              editinfos={this.props.editedfee}
              tracker={this.props.tracker}
              autocomplete={this.props.autocomplete}
              autocomplete2={this.props.autocomplete2}
              fetchMessage={this.props.fetchMessage}
              fetchMoreMessage={this.props.fetchMoreMessage}
            />
          </Dialog>
          <FeesListFilter
            feetypes={this.props.feetypes}
            onSubmit={this.handleFilter.bind(this)}
            // groupsbyyear={this.props.groupsbyyear}
            errorMessage={this.props.errorMessage} />
          <div>
            <FlatButton label="CSV Export" onClick={this.csvExport.bind(this)} />
          </div>
          <List>
          {
            this.props.message.map((option, index) => {
              let reasontext;
              let type;
              if (typeof option.type !== "undefined") {
                let typeHun;
                if (option.type === 'all') {
                  typeHun = 'összes'
                } else if (option.type === 'membership-fee') {
                  typeHun = 'tagdíj'
                  reasontext = 'év'
                } else if (option.type === 'registration-fee') {
                  typeHun = 'regisztrációs díj'
                  reasontext = 'pozíciószámú csoport'
                } else if (option.type === 'group-registration-fee') {
                  typeHun = 'csoport regisztrációs díj'
                  reasontext = 'pozíciószámú csoport'
                } else {
                  typeHun = option.type
                }
                if (option.type.length > 0) {
                  type = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Típus:</span>
                    <span> {typeHun} </span>
                  </span>
                }
              }

              let reason;
              if (typeof option.reason !== "undefined") {
                if (option.reason.length > 0) {
                  reason = <span>
                    <span style={{color: darkBlack}}> {option.reason} </span>
                  </span>
                }
              }

              let plusClass;
              if (option.isRemissed !== true && typeof option.debit !== "undefined" && option.debit !== 0) {
                plusClass = 'hasDebit'
              }

              let debit;
              if (typeof option.debit !== "undefined" && (option.type === 'membership-fee' || option.type === 'registration-fee') ) {
                debit = <span className={plusClass}>
                  <span> </span>
                  <span> Tartozás:</span>
                  <span> {option.debit} Ft </span>
                </span>
              }
              let paymentDate;
              if (typeof option.paymentDate !== "undefined") {
                if (option.paymentDate.length > 0) {
                  paymentDate = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Befizetés dátuma:</span>
                    <span> {option.paymentDate} </span>
                  </span>
                }
              }
              let invoiceNumber;
              if (typeof option.invoiceNumber !== "undefined") {
                if (option.invoiceNumber.length > 0) {
                  invoiceNumber = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Számla száma:</span>
                    <span> {option.invoiceNumber} </span>
                  </span>
                }
              }
              //let noticeCount;
              //if (typeof option.noticeCount !== "undefined") {
              //  if (option.noticeCount.length > 0) {
              //    noticeCount = <span>
              //      <span> </span>
              //      <span style={{color: darkBlack}}>Kiértesítve</span>
              //      <span> {option.noticeCount} alkalommal</span>
              //    </span>
              //  }
              //}
              //let isRemissed;
              //if (option.isRemissed === true) {
              //  isRemissed = <span>
              //    <span> </span>
              //    <span style={{color: darkBlack}}>ELENGEDVE</span>
              //  </span>
              //}
              return <ListItem
                onClick={this.handleOpen.bind(this, option.editPath, reason+' '+reasontext, option.type)}
                key={index}
                leftIcon={<ActionPayment />}
                primaryText={
                  <span>
                    <span style={{color: darkBlack}}>
                      {reason} <small>{reasontext}</small>
                    </span>
                    <small style={{color: lightBlack}}>
                      <span> - </span>
                      {type}
                      {debit}
                      {paymentDate}
                      {invoiceNumber}
                    </small>
                  </span>
                }
                />
            })
          }
          </List>
          <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
              if (this.props.message.length > 49) {
                this.props.fetchMoreMessage('/fees', params+'&offset='+this.props.message.length+'&limit=50');
              }
            }}
          />
          <FloatingActionButton className="plusFee" style={styles.plusButton} onClick={this.handleNewOpen.bind(this, uu, null)} key={uu}>
            <ContentAdd />
          </FloatingActionButton>
        </div>
      )
    } else {
      return (
        <div>
          <p style={{margin: 16, textAlign: "center"}}><strong>Töltünk...</strong></p>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    message: state.auth.message,
    feetypes: state.fees.feetypes,
    thisfee: state.fees.thisfee,
    editedfee: state.fees.editedfee,
    tracker: state.form.fees,
    autocomplete: state.fees.autocomplete,
    autocomplete2: state.fees.autocomplete2,
    // groupsbyyear: state.statistics.groupsbyyear,
    errorMessage: state.auth.error
  }
}

export default connect(mapStateToProps, actions)(Fees)


// WEBPACK FOOTER //
// ./src/components/fees/fees.js